import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
//import { URLAPIEMPLEADOS, LOGINAPIEMPLEADOS } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Usuarios';
export interface UsuarioEln {
	apellidosNombre: string
}

export class EmpleadosAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT,API_SLUG);
	}

	ListarUsuariosElecnor(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarEmpleados`);
	}

	ListarUsuariosExpatriados(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarEmpleadosExpatriados`);
	}

	ListarGruposFacturacionExpatriados(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarGruposFacturacionExpatriados`);
	}

	ListarValidadoresAS400(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarValidadoresAS400`);
	}
}